import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { renderToBody } from './render-to-body';
export function renderImperatively(element) {
  var Wrapper = React.forwardRef(function (_, ref) {
    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        visible = _useState2[0],
        setVisible = _useState2[1];

    var closedRef = useRef(false);

    var _useState3 = useState(element),
        _useState4 = _slicedToArray(_useState3, 2),
        elementToRender = _useState4[0],
        setElementToRender = _useState4[1];

    var keyRef = useRef(0);
    useEffect(function () {
      if (!closedRef.current) {
        setVisible(true);
      } else {
        afterClose();
      }
    }, []);

    function onClose() {
      var _a, _b;

      closedRef.current = true;
      setVisible(false);
      (_b = (_a = elementToRender.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }

    function afterClose() {
      var _a, _b;

      unmount();
      (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }

    useImperativeHandle(ref, function () {
      return {
        close: onClose,
        replace: function replace(element) {
          var _a, _b;

          keyRef.current++;
          (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
          setElementToRender(element);
        }
      };
    });
    return React.cloneElement(elementToRender, Object.assign(Object.assign({}, elementToRender.props), {
      key: keyRef.current,
      visible: visible,
      onClose: onClose,
      afterClose: afterClose
    }));
  });
  var wrapperRef = React.createRef();
  var unmount = renderToBody(React.createElement(Wrapper, {
    ref: wrapperRef
  }));
  return {
    close: function close() {
      var _a;

      (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.close();
    },
    replace: function replace(element) {
      var _a;

      (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.replace(element);
    }
  };
}